const openSearch = document.getElementById("openSearch");
const drawer = document.getElementById("searchDrawer");
const input = document.getElementById("liveSearchInput");
const results = document.getElementById("searchResults");

openSearch.addEventListener("click", () => {
  drawer.classList.toggle("active");
  input.focus();
});

input.addEventListener("keyup", async () => {
  const query = input.value.trim();
  if (query.length < 2) {
    results.innerHTML = "";
    return;
  }

  const res = await fetch(`/search/suggest.json?q=${query}&resources[type]=product`);
  const data = await res.json();

  const products = data.resources.results.products;

  results.innerHTML = products
    .map(
      (p) =>
        `<a href="${p.url}">
          <strong>${p.title}</strong>
        </a>`
    )
    .join("");
});


